<template>
  <div class="max-w-3xl mx-auto mt-5">
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
      <div class="px-4 py-5 border-b border-gray-200 sm:px-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          {{ report.name }} - {{ report.createdAt | dateFilter }}
        </h3>
      </div>
      <div class="px-4 py-5 sm:p-0">
        <dl>
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Total Carts
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ report.total }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Sent
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ report.success }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Failed/Not on whatsapp
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              {{ report.failed }}
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Numbers sent
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              <span v-for="checkout in successfulCheckouts" :key="checkout.id">
                {{ checkout.customer.phoneNumber }}
              </span>
            </dd>
          </div>
          <div
            class="mt-8 sm:mt-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:px-6 sm:py-5"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Numbers Failed
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2"
            >
              <span v-for="checkout in failedCheckouts" :key="checkout.id">
                {{ checkout.customer.phoneNumber }}
              </span>
              <span v-if="failedCheckouts.length === 0">No failed numbers</span>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "ReportDetails",
  data() {
    return {
      report: {},
      checkouts: []
    };
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  computed: {
    successfulCheckouts() {
      return this.checkouts.filter(checkout => {
        if (
          checkout.customerMeta?.shouldNotDisturb ||
          checkout.customerMeta?.isNotOnWhatsapp ||
          !checkout.isMessageSent
        ) {
          return false;
        }
        return true;
      });
    },
    failedCheckouts() {
      return this.checkouts.filter(checkout => {
        if (
          checkout.customerMeta?.shouldNotDisturb ||
          checkout.customerMeta?.isNotOnWhatsapp ||
          !checkout.isMessageSent
        ) {
          return true;
        }
        return false;
      });
    }
  },
  created() {
    const reportId = this.$route.params.reportId;
    this.$store.dispatch("getReport", { reportId }).then(response => {
      this.report = response.report;
      this.checkouts = response.checkouts;
    });
  }
};
</script>

<style lang="scss" scoped></style>
